<mat-card class="detail-card" valumizeCardContextMenu [commentScope]="'asset-fund-valuation-forecast'" [commentSlug]="'asset-valuation-forecast'">
    <mat-card-header class="detail-card-header">
        <mat-card-title>Company Valuation (Forecast)</mat-card-title>
    </mat-card-header>
    <mat-card-content class="detail-card-content">
        @if ((fovCreateError | async); as createErrorMsg) {
            <valumize-info-panel
                [appearance]="'WARNING'" [message]="createErrorMsg"></valumize-info-panel>
        }
        <!-- US-1189: read-only note that the user confirmed this asset to be a write-off. Read from the
             preferred valuation — the same one the fund's partnership-investments table reflects — so it
             covers both the DMV and the FOV tab. Entering forecast cashflow clears it server-side. -->
        @if ((selectedPreferredValuation$ | async)?.isWriteoff?.value) {
            <valumize-info-panel data-test="writeoff-confirmed-panel"
                                 [appearance]="'INFO'"
                                 [message]="'Confirmed as a write-off — no proceeds expected. Entering forecast cashflow ends the write-off.'"></valumize-info-panel>
        }
        @if (selectedAssetValuationsForAssetAndFundValuation$ | async; as assetValuations; ) {
            @if (assetValuations.length !== 0) {
                <mat-tab-group [selectedIndex]="selectedIndex$ | async" (selectedIndexChange)="onTabChange($event, assetValuations)">
                    @if (valuationTypeExists(assetValuations, valuationTypeEnum.DiscountMultipleValuation)) {
                        <mat-tab tabindex="0" label="Discount Multiple Valuation"
                                 data-test="tab-discount-multiple-valuation">
                            <ng-template matTabContent>
                                <valumize-asset-discount-multiple-valuation></valumize-asset-discount-multiple-valuation>
                            </ng-template>
                        </mat-tab>
                    }
                    @if (valuationTypeExists(assetValuations, valuationTypeEnum.FinancialOperationalValuation)) {
                        <mat-tab tabindex="1" label="Financial Operational Valuation"
                                 data-test="tab-operational-valuation">
                            <ng-template matTabContent>
                                <valumize-asset-financial-operational-valuation [assetId]="assetId"></valumize-asset-financial-operational-valuation>
                            </ng-template>
                        </mat-tab>
                    }
                </mat-tab-group>
            } @else {
                <span style="color: grey">Please select valuation first!</span>
                @if (!fundValuationId && fundId && fundReportId) {
                    <button mat-stroked-button color="primary" (click)="openSelectValuationDialog(fundId, fundReportId)" class="select-valuation-button">
                        Select Valuation
                    </button>
                }
            }
        }
    </mat-card-content>
    <mat-card-actions class="detail-card-actions">
        @if (selectedAssetValuationsForAssetAndFundValuation$ | async; as assetValuations) {
            @if (assetValuations.length !== 0) {
                @let preferredValuation = selectedPreferredValuation$ | async;

                @if (!preferredValuation) {
                    <valumize-info-panel
                        [appearance]="'WARNING'"
                        [message]="'No calculation base is set for this company. Select one below to restore its fund-level valuation.'"></valumize-info-panel>
                }

                @if (assetValuations.length > 1 || !preferredValuation) {
                    <mat-form-field class="calculation-base-dropdown">
                        <mat-label>Calculation Base</mat-label>
                        <mat-select [value]="preferredValuation?.id" (valueChange)="changePreferredType($event)"
                                    [disabled]="(isEditDisabled$ | async)" placeholder="Select calculation base"
                                    data-test="calculation-base-select">
                            @for (valuation of assetValuations; track valuation) {
                                <mat-option [value]="valuation.id">
                                    {{ valuation.valuationType.code | codeFormat: codeTableValuationType | async }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                }
                @if (filterExisting(assetValuations).length !== 0) {
                    <button [matMenuTriggerFor]="dropdownAddValuation" mat-stroked-button color="primary"
                            data-test="new-valuation" [disabled]="(isEditDisabled$ | async) || (isCreatingValuation$ | async)">
                        <mat-icon>add</mat-icon>
                        Valuation
                    </button>
                }
                <mat-menu #dropdownAddValuation>
                    @for (valuationType of filterExisting(assetValuations); track valuationType) {
                        <button mat-menu-item (click)="createAssetValuation(valuationType)">
                            <mat-icon>add</mat-icon>
                            Add {{ valuationType | codeFormat: codeTableValuationType | async }}
                        </button>
                    }
                </mat-menu>
            }
        }
        <valumize-card-comments-button [commentScope]="'asset-fund-valuation-forecast'" [commentSlug]="'asset-valuation-forecast'"></valumize-card-comments-button>
    </mat-card-actions>
</mat-card>
